import isNumber from 'lodash.isnumber';
import { FormFieldValidator, ValidationResult } from './FormFieldValidator';
import { CustomerIdAndOrderIdIntegrityResponse } from '../../../services/connectors/CustomerIdAndOrderIdIntegrityResponse';
import { ContactFormConnector } from '../../../services/connectors/ContactFormConnector';
import { OrderCompositeField } from '../types';

export class CustomerIdAndOrderIdIntegrityValidator extends FormFieldValidator {
  constructor(
    private readonly customerId: string,
    private readonly order: OrderCompositeField,
    private readonly onBeforeValidation: () => any,
    private readonly onAfterValidation: () => any,
    private readonly onValidationResult: (arg: CustomerIdAndOrderIdIntegrityResponse) => any,
    private readonly isUserLoggedIn: boolean,
  ) {
    super(true);
  }

  async validate(): Promise<ValidationResult> {
    if (
      this.isEmpty(this.customerId) ||
      this.isEmpty(this.order.suborderId) ||
      !isNumber(Number(this.customerId)) ||
      !this.isUserLoggedIn
    ) {
      return ValidationResult.create(true);
    }

    this.onBeforeValidation();

    return this.requestAsyncValidation()
      .then((result: CustomerIdAndOrderIdIntegrityResponse) => {
        this.onValidationResult(result);
        return this.serviceResponseToValidationResult(result);
      })
      .catch((e) => {
        console.log('Error occurred when checking Customer ID and Order ID integrity', e);
        return ValidationResult.create(true);
      })
      .finally(() => {
        this.onAfterValidation();
      });
  }

  async requestAsyncValidation() {
    return new ContactFormConnector().checkCustomerIdAndOrderIdIntegrityV2(
      this.order.orderId,
      this.order.suborderId,
    );
  }

  private serviceResponseToValidationResult(
    response: CustomerIdAndOrderIdIntegrityResponse,
  ): ValidationResult {
    const isValid = response.customerIdAndOrderIdMatch;
    let errorTags = [] as string[];
    if (!isValid) {
      errorTags = ['customer_id_and_order_id_do_not_match'];
    }
    return ValidationResult.create(isValid, errorTags);
  }
}
